import { useForm } from 'react-final-form';
import React, { useEffect } from 'react';
import * as T from 'prop-types';
import GenericToggleButtonGroupField from '../../../commons/form-fields/GenericToggleButtonGroupField';
import { yesNoOptions, yesNoOptionsWithNA } from '../../OnboardingConstants';
import GenericTextAreaInputField from '../../../commons/form-fields/GenericTextAreaInputField';
import GenericSelectInputField from '../../../commons/form-fields/GenericSelectInputField';

const QuestionField = (props) => {
    const { question, prefix, projectCompanies } = props;
    const fieldName = `${prefix}${question.qid || question.fqid}.answer`;
    const required = question.isOptional === false;
    const { helpText, text, questionType } = question;
    let questionText = text;
    questionText = questionText.replace(
        '[TARGET and TOPICS]',
        projectCompanies
    );
    const questionSpan = (
        <span dangerouslySetInnerHTML={{ __html: questionText }} />
    );

    const form = useForm();
    useEffect(
        () =>
            // if the question is rendered dynamically, and unmounted
            // at any point, clear it's value since react-final-form
            // doesn't clear value of a field when it is unmounted.
            () =>
                form.change(fieldName),
        []
    );

    return (
        <div>
            {questionType === 'YES_NO' && (
                <GenericToggleButtonGroupField
                    name={fieldName}
                    inlineLabel={questionSpan}
                    options={yesNoOptions}
                    required={required}
                />
            )}

            {questionType === 'YES_NO_WITH_NA' && (
                <GenericToggleButtonGroupField
                    name={fieldName}
                    inlineLabel={questionSpan}
                    options={yesNoOptionsWithNA}
                    required={required}
                />
            )}

            {questionType === 'DESCRIPTION' && (
                <GenericTextAreaInputField
                    name={fieldName}
                    placeholder={helpText}
                    label={questionSpan}
                    required={required}
                />
            )}

            {questionType === 'DROP_DOWN' && (
                <GenericSelectInputField
                    name={fieldName}
                    label={questionSpan}
                    options={(
                        JSON.parse(question?.otherProps ?? '{}')?.options ?? []
                    ).map((option) => ({
                        label: option,
                        value: option,
                        key: option,
                    }))}
                    required={required}
                />
            )}
        </div>
    );
};

QuestionField.propTypes = {
    prefix: T.string,
    question: T.object,
    projectCompanies: T.string,
};

export default QuestionField;
